import { Stack } from '@mui/material'
import TabHeader from './TabHeader'
import DeliveryAddress from './DeliveryAddress'

const SearchAddressTab = () => {
  return (
    <Stack direction='column' gap={2}>
      <TabHeader
        title='Delivery address'
        caption='Please confirm your delivery address so we can include any freight costs'
      />
      {/* TODO: integrate based on config later. <DeliveryAddress /> or <PickupSite /> or both */}
      <DeliveryAddress />
    </Stack>
  )
}

export default SearchAddressTab
